import { Select, styled } from "@mui/material";

const NoBorderSelect = styled(Select)((_) => ({
    fontWeight: 500,
    minWidth: '8vw',
    textAlign: "left",
    borderRadius: '1vw',
    margin: 0,
    padding: '0.125vh 0.125vw',
    textTransform: 'uppercase',
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '&:focus .MuiOutlinedInput-notchedOutline': {
        border: 'none',
        outline: 'none',
    },
}))

export default NoBorderSelect;